import { Group } from './Types'
import { TextChannelKey } from 'types'
import { ASPECT_RATIOS, AspectRatioKey } from 'components/NewFileModal/Types'
import { TextChannels } from '../../../constants'
import * as JsSearch from 'js-search'

type TaggedDocument = {
  key: TextChannelKey
  name: string
  tags: string[]
  group: Group
}

type AspectRatioDocument = {
  key: AspectRatioKey
  name: string
  group: Group
  width: number
  height: number
  aspectRatio: string
}

type Document = TaggedDocument | AspectRatioDocument

export const useSearchGroups = () => (groups: Group[], searchString: string, selectedGroup?: string) => {
  let filteredGroups = groups
  if (selectedGroup) {
    filteredGroups = groups.filter((group) => group.name === selectedGroup)
  }

  if (!searchString || searchString.length < 1) {
    return filteredGroups
  }

  const search = new JsSearch.Search('key')
  search.indexStrategy = new JsSearch.AllSubstringsIndexStrategy()
  search.addIndex('name')
  search.addIndex('tags')
  search.addIndex(['group', 'name'])
  search.addIndex('width')
  search.addIndex('height')
  search.addIndex('aspectRatio')

  filteredGroups.forEach((group) => {
    group.channels.forEach((channelKey) => {
      const isTaggedChannel = Object.keys(TextChannels).includes(channelKey as TextChannelKey)
      const isDesignChannel = Object.keys(ASPECT_RATIOS).includes(channelKey as AspectRatioKey)

      if (isTaggedChannel) {
        const channel = TextChannels[channelKey as TextChannelKey]
        search.addDocuments([{ ...channel, group, key: channelKey }])
      }

      if (isDesignChannel) {
        const channel = ASPECT_RATIOS[channelKey as AspectRatioKey]
        search.addDocuments([{ ...channel, group, key: channelKey, aspectRatio: `${channel.width}x${channel.height}` }])
      }
    })
  })

  const foundGroups: Group[] = []
  ;(search.search(searchString) as Document[]).forEach((document: Document) => {
    const existingGroup = foundGroups.find((group) => group.name === document.group.name)
    if (existingGroup) {
      existingGroup.channels.push(document.key)
    } else {
      foundGroups.push({
        name: document.group.name,
        channels: [document.key],
      })
    }
  })

  return foundGroups
}
